<template>
<!-- eslint-disable vue/valid-v-slot -->
  <v-container fluid>
    <printHeader class="d-none d-print-flex" ></printHeader>
    <v-data-table
    :headers="headers"
    :items="unloadData"
    item-key="Number(startTime)"
    :loading="dataLoading"
    hide-default-header
    hide-default-footer
    :no-data-text="$t('No Data Available')"
    :items-per-page="itemsPerPage"
    :page.sync="page"
    @page-count="pageCount = $event"
    :search="filterTmrCode || filterGroupCode"
    :custom-filter="filterTMR"
    :group-by="groupByDay ? 'Group' : 'grpCode'"
  >
    <template v-slot:top>
      <v-toolbar flat  color="secondary darken-1" height="140px" >
        <v-layout wrap class="ma-0">
          <v-row align="start" class="pt-4">
            <v-col xs12 sm4 class="my-0  py-0">
              <v-toolbar-title class="pb-2 primary--text">{{$t('Deliveries')}}</v-toolbar-title>
            </v-col>
            <v-col xs6 sm4 class="px-2 my-0 py-0">
              <PickDate v-model="fromDate" @input="fromDate=$event" :label="$t('From Date')"> </PickDate>
            </v-col>
            <v-col xs6 sm4 class="px-2 my-0 py-0">
              <PickDate v-model="toDate" @input="toDate=$event" :label="$t('To Date')"> </PickDate>
            </v-col>

          </v-row>
          <v-row class="my-0 py-0" justify="end">
          <v-col xs12 sm4 class="my-1  py-0">
            <v-row no-gutters>
              <v-col cols="1" sm="3">
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn icon large color="primary" v-on="on" class="ms-1 mt-sm-0 mt-n6 dense"
                      @click="csvExport">
                      <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('Export report data to a file in Excel format')}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="11" sm="9">
                <v-switch inset hide-details dense color="primary darken-2" class="mt-3"
                   v-model="groupByDay" :label="$t('Group by_day')">
                </v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col xs6 sm4 class="px-2 py-0">
            <v-select flat class="py-0" :items="dropdown_tmrs" v-model="filterTmrCode"
              :label="$t('Filter TMR')" editable item-value="code">
            </v-select>
          </v-col>
          <v-col xs6 sm4 class="px-2 py-0">
            <v-select flat class="py-0" :items="dropdown_groups" v-model="filterGroupCode"
              :label="$t('Filter Group')" editable item-value="code">
            </v-select>
          </v-col>
          </v-row>
        </v-layout>
      </v-toolbar>
    </template>

    <template v-if="$vuetify.breakpoint.smAndUp" v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th v-for="hdr in headers" :key="hdr.index"
            class="subtitle-2 font-weight-bold"
            :class="{'text-right': hdr.align == 'right', 'text-center': hdr.align == 'center'}" >
            {{hdr.text.toUpperCase()}}
          </th>

        </tr>
      </thead>
    </template>

    <template v-slot:group.header="{items, headers, isOpen, toggle}">
      <td :colspan="headers.length" style="background-color: #1e1e1e">
        <v-btn text icon small color="white">
          <v-icon @click="toggle">
            {{isOpen ? "mdi-minus" : "mdi-plus"}}</v-icon>
        </v-btn>
        <span class="mx-2 subtitle-2">
          {{groupName(items[0].groupId, items[0].grpCode)  +
            (groupByDay ? " " + $t('for') + " " + items[0].startTime.toLocaleDateString([], { dateStyle: "short" }) : "")}}
        </span>
      </td>
    </template>
    <template v-slot:group.summary="grp" >
        <td colspan="3" class="secondary">
          <span class="px-1 subtitle-2">
            {{(groupByDay ? " " + $t('Total for') + " " + grp.items[0].Group : " " + $t('Total for Group') + grp.items[0].grpCode)}}
          </span>
        </td>
        <td colspan="1" class="text-right secondary">
          <span class="px-1 subtitle-2">
            <u>{{groupDailyQty(grp.items) | kgString}}</u>
          </span>
        </td>
        <td colspan="1" class="text-right secondary">
          <span class="px-1 subtitle-2">
            <u>{{groupDailyPlanned(grp.items) | kgString}}</u>
          </span>
        </td>
        <td colspan="1" class="text-right secondary">
          <span class="px-1 subtitle-2"
              :class="{'error--text text--lighten-1': Math.abs(groupDailyDiff(grp.items)) > 5 }"
          >
            <u>{{groupDailyDiff(grp.items) | percentValue}}</u>
          </span>
        </td>
        <td colspan="1" class="text-right secondary">
          <span class="px-1 subtitle-2" v-if="groupByDay">
            <u>{{groupDailyPercent(grp.items) | percentValue}}</u>
          </span>
        </td>
        <td class="secondary"> </td>
		</template>
    <template v-slot:item.startTime="{ item }">
      <span v-if="groupByDay" class="ps-1">{{item.startTime | timeString}}</span>
      <span v-else class="ps-1">{{item.startTime | dateTimeString}}</span>
		</template>
    <template v-slot:item.status="{ item }">
			<span class="ps-1" :class="{'error--text text--lighten-1': item.status >=4 }">
        {{getStatus(item.status)}}</span>
		</template>
    <template v-slot:item.tmrId="{ item }">
      <span>{{getTMR(item.tmrId)}}</span>
    </template>
    <template v-slot:item.groupId="{ item }">
      <span>{{groupName(item.groupId, item.grpCode)}}</span>
    </template>
    <template v-slot:item.qty="{ item }">
      <span>{{item.qty | kgString}}</span>
    </template>
    <template v-slot:item.qtyNeeded="{ item }">
      <span>{{item.qtyNeeded | kgString}} </span>
    </template>
    <template v-slot:item.diff="{ item }">
      <span :class="{'error--text text--lighten-1': Math.abs(item.diff) > 5 }">
        {{item.diff | percentValue}}
      </span>
    </template>
    <template v-slot:item.dailyPercent="{ item }">
      <span>
        {{item.dailyPercent | percentValue}}
      </span>
    </template>


  </v-data-table>
      <v-layout class="text-center pt-4">
      <v-flex sx12 sm3>
       <v-select
          :items="perPageList"
          :label="$t('Items per page')"
          :value="itemsPerPage"
          @input="itemsPerPage = parseInt($event, 10)"
          type="number"
          class="my-0 ml-1 mr-0 py-0"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm9>
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import PickDate from "../components/common/PickDate";
import getter from "../store/reportGetters";
import printHeader from "../components/common/PrintHeader";

export default {
  name:"ReportDeliveries",
  components: {
     "PickDate": PickDate,
     "printHeader": printHeader
  },
  data() {
    return {
      fromDate: "",
      toDate: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 25,
      filterTmrCode: "",
      filterGroupCode: "",
      dataLoading: true,
      groupByDay: true,
      perPageList: [
        {text: "10", value: 10 },
        {text: "25", value: 25 },
        {text: "50", value: 50 },
        {text: "100", value: 100 },
        {text: "1000", value: 1000 },
      ],
      headers: [
        { text: this.$i18n.t('Start Time'), width: "16%", align: "left", value: "startTime"},
        { text: this.$i18n.t('TMR'), width: "16%", align: "left", value: "tmrId"},
        { text: this.$i18n.t('Group'), width: "14%", align: "left", value: "groupId"},
        { text: this.$i18n.t('Actual'), width: "12%", align: "right", value: "qty"},
        { text: this.$i18n.t('Planned'), width: "12%", align: "right", value: "qtyNeeded"},
        { text: this.$i18n.t('Diff_'), width: "10%", align: "right", value: "diff"},
        { text: this.$i18n.t('Daily_'), width: "10%", align: "right", value: "dailyPercent"},
        { text: this.$i18n.t('Status'), width: "10%", align: "center", value: "status"}
      ],
      unloadData: [],
    }
  },
  created() {
    let d = new Date();
    d.setDate(d.getDate()-3);
    this.fromDate = d.toISOString().substr(0, 10)
    this.toDate = new Date().toISOString().substr(0, 10)
    //list of TMRS
    this.dropdown_tmrs = this.$store.getters.getTMRs.map(function(x) {
        return {text: x.code + "-" + x.name, code: x.code +""}
      });
    if (this.dropdown_tmrs.findIndex((x)=> x.code == "") == -1)
      this.dropdown_tmrs.unshift({text: this.$i18n.t('Show All'), code:""});
    //List of Groups
    this.dropdown_groups = this.$store.getters.getGroups.map(function(x) {
        return {text: x.code + "-" + x.name, code: x.code +""}
      });
    if (this.dropdown_groups.findIndex((x)=> x.code == "") == -1)
      this.dropdown_groups.unshift({text: this.$i18n.t('Show All'), code:""});

    this.loadDeliveryData();
  },
  watch: {
    fromDate: function() {
      if (! this.dataLoading)
      this.loadDeliveryData();
    },
    toDate: function() {
      if (! this.dataLoading)
      this.loadDeliveryData();
    },
  },
  methods: {
    loadDeliveryData: function() {
      this.dataLoading = true;
      getter.getActualDeliveries(this.fromDate, this.toDate, this.$store.state).then((data) => {
        this.unloadData = data;
        this.dataLoading = false;
      });
    },
    filterTMR( value, search, item) {
      let tmrCode = this.filterTmrCode;
      let groupCode = this.filterGroupCode;
      return item &&
        (tmrCode == "" || item.tmrCode == tmrCode) &&
        (groupCode == "" || item.grpCode == groupCode)
    },
    getStatus(status) {
      const wagonStatus = [this.$i18n.t('WIP'),this.$i18n.t('WIP'), this.$i18n.t('WIP'), this.$i18n.t('Ok'), this.$i18n.t('Review'), this.$i18n.t('Manual')];
      return wagonStatus[status];
    },
    getDayHeader(grp) {
      let x = grp.items[0];
      if (x)
        return this.$i18n.t('Date') + ": " + x.startTime.toLocaleDateString([], {year: "numeric", month: "2-digit", day:"2-digit"});
      else
        return " " + this.$i18n.t('Day');
    },
    groupName(groupId, code) {
      if (!groupId) return "";
      let group = this.$store.getters.getGroup(groupId);
      return group ? group.code +"-"+ group.name : code;
    },
    getTMR(tmrId) {
      if (!tmrId) return "";
      let tmr = this.$store.getters.getTMR(tmrId);
      return tmr ? tmr.code +"-"+ tmr.name : this.$i18n.t('unknown');
    },
    groupDailyQty(items) {
      if (!items) return 0;
      return items.reduce(function (a, b) {
          return isNaN(Number(b["qty"])) ? a : a + Number(b["qty"]);
      }, 0)
    },
    groupDailyPlanned(items) {
      if (!items) return 0;
      return items.reduce(function (a, b) {
          return isNaN(Number(b["qtyNeeded"])) ? a : a + Number(b["qtyNeeded"]);
      }, 0)
    },
    groupDailyPercent(items){
      if (!items) return 0;
      return items.reduce(function (a, b) {
          return isNaN(Number(b["dailyPercent"])) ? a : a + Number(b["dailyPercent"]);
      }, 0)
    },
    groupDailyDiff(items) {
      let planned = this.groupDailyPlanned(items);
      return planned ? Math.round((this.groupDailyQty(items) - planned) * 1000 / planned)/10 : 0;
    },
    wgnFromWgnId(wgnId) {
      let wgnNameArray = wgnId.split("-") || [];
      wgnNameArray.shift();
      return wgnNameArray.join("");
    },
    csvExport() {
      let separator = this.$store.getters.getSeparator;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        [this.$i18n.t('Wagon'),
          this.$i18n.t('TMR'), this.$i18n.t('Group Code'), this.$i18n.t('Qty') ,
          this.$i18n.t('Planned'), this.$i18n.t('Start Time'), this.$i18n.t('Status'),
          this.$i18n.t('Daily_'), this.$i18n.t('Diff_'), this.$i18n.t('Group by_day')
        ]
        .join(separator),
        ...this.unloadData.map(item =>
        [
          this.wgnFromWgnId(item.wgnId), item.tmrCode, item.grpCode, item.qty, item.qtyNeeded,
          item.startTime, this.getStatus(item.status), item.dailyPercent, item.diff, item.Group
        ]
        .join(separator))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "deliveries.csv");
      link.click();
    }
  },
}
</script>

<style>
  .table-border.v-table {
    border:1px solid white !important;
    /* border-right-style: solid;
    border-right-width: 2px;
    border-right-color: azure;
    overflow-x: hidden !important; */
  }
  .table-border .v-data-table__wrapper {
    border:1px solid white;
    table-layout: fixed;
  }
  .v-data-table td, .v-data-table th {
    padding: 0px 4px;
  }
  .v-row-group__summary tr{
    margin-bottom: 10px !important;
    background-color: #1e1e1e !important;
    border-bottom-width: 3px;
  }


</style>